import React, {Component, Fragment} from 'react'
import styled from 'styled-components'
import { Table, Icon } from 'semantic-ui-react'

export default class DirectoryDetails extends Component {
    state = {
        
    }

    render(){
        const {directory, address} = this.props

        return(
            <MainContainer colSpan='3'>
                <Title>{directory.place_name}</Title>
                <Address>{address}</Address>
                <DetailsContainer>
                    <ContactDetails>
                        {directory.coordinates.tels_labels.map((label, index) => {
                            let data = directory.coordinates.tels[index]
                            const email_regex = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$", "ig")
                            const website_regex = new RegExp("^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$")
                            const http_regex = new RegExp('http:\/\/')
                            const is_email = data.match(email_regex)
                            const is_website = data.match(website_regex)
                            const is_http = data.match(http_regex)
                            if(is_website && !is_http){
                                data = "http://" + data
                            }
                            const icon = is_website ? "world" : is_email ? "mail" : ""
                            console.log('is_website', is_website)
                            if(data){
                                return(
                                    <Contact>
                                        <ContactLabel>{icon && <Icon name={icon} style={{marginRight: "0.5em"}} />}{label}</ContactLabel>
                                        {is_email ?
                                            <a href={`mailto:${data}`} style={{fontWeight: "initial"}}>{data}</a>
                                        :
                                        is_website ?
                                            <a href={data} target="_blank" style={{fontWeight: "initial"}}>{data}</a>
                                        :
                                            <div style={{fontWeight: "initial"}}>{data}</div>
                                        }
                                    </Contact>
                                )
                            }
                        })}
                    </ContactDetails>
                    <InfoDetails>
                        <div dangerouslySetInnerHTML={{__html: directory.infos_explain }} />
                    </InfoDetails>
                </DetailsContainer>
                <SignalLink href={`mailto:info@fney.asso.fr?subject=FNEYnuaire : Signalement de contenu abusif, ID ${directory.id}&body=Merci de bien vouloir laisser votre commentaire`}>
                    Signaler un contenu abusif
                </SignalLink>
            </MainContainer>
        )
    }
}

const MainContainer = styled(Table.Cell)`
    
`

const ContactDetails = styled.div`
    flex-grow: 2;
`

const Address = styled.div`
    font-size: 1.2em;
    margin-bottom: 1em;
    font-weight: initial;
`

const Contact = styled.div`
    margin-bottom: 0.5em;
`

const ContactLabel = styled.div`
    font-weight: bold;
`


const Title = styled.h1`
    margin-bottom: 0;
`

const DetailsContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
`

const InfoDetails = styled.div`
    flex-grow: 1;
    font-weight: initial;
`

const SignalLink = styled.a`
    float: right;
    font-size: 0.8em;
`


// WEBPACK FOOTER //
// ./src/DirectoryDetails.js